if (!customElements.get('facets-horizontal')) {
  class FacetsHorizontal extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get dropdowns() {
      return Array.from(this.querySelectorAll('.facets__horizontal-dropdown'));
    }

    onClick(event) {
      const summary = event.target.closest('.facets__horizontal-summary');
      if (!summary || !this.contains(summary)) return;

      event.preventDefault();

      const details = summary.parentElement;
      const willOpen = details.getAttribute('data-state') !== 'open';

      this.closeAll(details);
      this.setOpen(details, willOpen);
    }

    onChange(event) {
      // close the dropdown once a checkbox is selected (price range keeps it open)
      const input = event.target;
      if (!input.matches || !input.matches('input[type="checkbox"]')) return;
      const details = input.closest('.facets__horizontal-dropdown');
      if (details) this.setOpen(details, false);
    }

    onDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.closeAll();
    }

    onKeyDown(event) {
      if (event.key !== 'Escape') return;
      this.closeAll();
    }

    setOpen(details, open) {
      const summary = details.querySelector('.facets__horizontal-summary');

      if (open) {
        if (details._closeTimer) {
          clearTimeout(details._closeTimer);
          details._closeTimer = null;
        }
        details.setAttribute('open', '');
        // next frame so the entry transition runs from the closed state
        requestAnimationFrame(() => details.setAttribute('data-state', 'open'));
        if (summary) summary.setAttribute('aria-expanded', 'true');
      } else {
        if (!details.hasAttribute('open')) return;
        details.setAttribute('data-state', 'closed');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        // keep mounted until the exit transition finishes, then unmount
        details._closeTimer = setTimeout(() => {
          if (details.getAttribute('data-state') === 'closed') {
            details.removeAttribute('open');
            details.removeAttribute('data-state');
          }
          details._closeTimer = null;
        }, 200);
      }
    }

    closeAll(except) {
      this.dropdowns.forEach((details) => {
        if (details === except) return;
        this.setOpen(details, false);
      });
    }
  }

  customElements.define('facets-horizontal', FacetsHorizontal);
}
